<template>
  <div :id="id" />
</template>
<script>
import Vditor from 'vditor';
import 'vditor/dist/index.css';
// import lightGallery from 'lightgallery';
// import 'lightgallery/css/lightgallery.css';
import VditorPreview from 'vditor/dist/method.min';
import 'viewerjs/dist/viewer.css';
import { api as viewerApi } from 'v-viewer';

VditorPreview.mermaidRender(document);
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '900px'
    }
  },
  data() {
    return {
      id: this.getRandom(5)
    };
  },
  watch: {
    content() {
      this.renderMarkdown(this.content);
    }
  },
  mounted() {
    this.renderMarkdown(this.content);
  },

  beforeDestroy() {
    // 清理事件监听器
    const viewerEl = document.getElementById(this.id);
    if (viewerEl && viewerEl._clickHandler) {
      viewerEl.removeEventListener('click', viewerEl._clickHandler);
      delete viewerEl._clickHandler;
    }
  },
  methods: {
    renderMarkdown(md) {
      const currentId = this.id;
      const viewerEl = document.getElementById(currentId);
      const self = this; // 保存组件实例的引用
      Vditor.preview(viewerEl, md, {
        after() {
          // lightGallery(document.getElementById(currentId), {
          //   selector: 'img' // 选择器设置为 img，表示所有 img 元素都会被 lightGallery 处理
          // });          // 渲染完成后修改所有链接属性
          const links = viewerEl.querySelectorAll('a');
          links.forEach(link => {
            if (link.textContent.startsWith('@')) {
              link.removeAttribute('href');
            } else if (link.classList.contains('requirement-link')) {
              // 需求链接不设置 target="_blank"，保持原有的 href
              link.style.cursor = 'pointer';
              link.style.color = '#1890ff';
              link.style.textDecoration = 'underline';
            } else {
              link.setAttribute('target', '_blank');
            }
          });

          // 先移除旧的事件监听器，避免重复绑定
          const oldClickHandler = viewerEl._clickHandler;
          if (oldClickHandler) {
            viewerEl.removeEventListener('click', oldClickHandler);
          }

          // 创建新的事件处理函数
          const clickHandler = event => {
            if (event.target.tagName === 'IMG' && event.target && event.target.src) {
              viewerApi({
                options: {
                  initialViewIndex: 0,
                  title: false,
                  navbar: false,
                  button: true,
                  toolbar: false
                },
                images: [event.target.src]
              });
            } else if (event.target.classList.contains('requirement-link')) {
              // 阻止需求链接的默认跳转行为
              event.preventDefault();
              event.stopPropagation();
              // 触发父组件的点击事件（如果父组件监听了的话）
              if (self.$listeners.click) {
                self.$emit('click', event);
              }
            }
          };

          // 保存事件处理函数引用，以便后续移除
          viewerEl._clickHandler = clickHandler;
          viewerEl.addEventListener('click', clickHandler);
        },
        cdn: process.env.VUE_APP_VDITOR_CDN,
        hljs: {
          style: 'github', // 样式
          lineNumber: true // 行号
        },
        theme: {
          current: 'light'
        },
        markdown: {
          toc: true
        }
      });
    },
    getRandom(len) {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const tempLen = chars.length;
      let tempStr = '';
      for (let i = 0; i < len; ++i) {
        tempStr += chars.charAt(Math.floor(Math.random() * tempLen));
      }
      return tempStr;
    }
  }
};
</script>
<style lang="less" scoped>
.vditor-reset {
  width: 100%;
  max-width: 960px;
  p {
    margin-top: 0;
    margin-bottom: 4px !important;
  }
  ol {
    margin-bottom: 0 !important;
  }
}
</style>
